/*
 * TIMESHEET-ACTION-CONFIRMATION-DIALOG - Confirmation dialog for timesheet approval/rejection
 * 
 * SUMMARY:
 * Enhanced to support adding comments during the approval or rejection process.
 */

import React, { useState, useEffect } from 'react'
import Modal from '../modal/modal'
import TextAreaInput from '../inputs/textarea-input'
import './../modal/modal.scss'

export default function TimesheetActionConfirmation(props) {
  const {
    open,
    dialogClose,
    onConfirm,
    action,
    count = 1,
    isBulk = false,
    description = 'Please confirm your action',
    hideCommentField = false,
    prefilledComment = ''
  } = props

  const [comment, setComment] = useState('')

  useEffect(() => {
    if (open) {
      if (prefilledComment) {
        setComment(prefilledComment)
      } else {
        setComment('')
      }
    }
  }, [open, prefilledComment])

  const getModalHeading = () => {
    if (isBulk) {
      switch (action) {
        case 'APPROVED':
          return 'Bulk Approve Timesheet Records'
        case 'REJECTED':
          return 'Bulk Reject Timesheet Records'
        case 'PENDING':
          return 'Bulk Set as Pending'
        case 'RECALCULATE':
          return 'Recalculate Timesheet Records'
        default:
          return 'Confirm Bulk Action'
      }
    } else {
      switch (action) {
        case 'APPROVED':
          return 'Approve Timesheet Record'
        case 'REJECTED':
          return 'Reject Timesheet Record'
        case 'PENDING':
          return 'Set as Pending'
        case 'RECALCULATE':
          return 'Recalculate Timesheet Record'
        default:
          return 'Confirm Action'
      }
    }
  }

  const getConfirmationMessage = () => {
    if (isBulk) {
      switch (action) {
        case 'APPROVED':
          return `Are you sure you want to approve ${count} selected timesheet record${count > 1 ? 's' : ''}?`
        case 'REJECTED':
          return `Are you sure you want to reject ${count} selected timesheet record${count > 1 ? 's' : ''}?`
        case 'PENDING':
          return `Are you sure you want to set ${count} selected timesheet record${count > 1 ? 's' : ''} as pending?`
        case 'RECALCULATE':
          return 'Recalculate the selected pending timesheets using each user’s current Work Hour Settings? Their status will remain Pending.'
        default:
          return description
      }
    } else {
      switch (action) {
        case 'APPROVED':
          return 'Are you sure you want to approve this timesheet record?'
        case 'REJECTED':
          return 'Are you sure you want to reject this timesheet record?'
        case 'PENDING':
          return 'Are you sure you want to set this timesheet record as pending?'
        case 'RECALCULATE':
          return 'Recalculate this pending timesheet using the user’s current Work Hour Settings? Its status will remain Pending.'
        default:
          return description
      }
    }
  }

  const handleConfirm = () => {
    onConfirm(action, comment)
  }

  return (
    <Modal
      open={open}
      onClose={dialogClose}
      fullWidth={true}
      maxWidth='sm'
      modalHeading={getModalHeading()}
      modalSaveTxt='Yes'
      modalCloseTxt='No'
      onClick={handleConfirm}
      showActionBtn
      savebtnClass='createBtn'
      cxlbtnClass='cancelBtn'
      primary
    >
      <p>{getConfirmationMessage()}</p>
      {!hideCommentField && (
        <div className="mt-3">
          <TextAreaInput
            label="Comment (Optional)"
            placeholder="Enter a comment..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
          />
        </div>
      )}
    </Modal>
  )
} 